var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnyIssues = function SvgAnyIssues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 23a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.172 7 8 10.828 9 9l1.828-1L7 4.172zM19.172 22 23 25.828 25.828 23 22 19.172 21 21zM23 4.172 19.172 8 21.5 9l.5 1.828L25.828 7zM8 19.172 4.172 23 7 25.828 10.828 22 9 21.5z"
  })));
};
export default SvgAnyIssues;